import { Table } from 'antd';
import PropTypes from 'prop-types';
import { BaseTablePagination } from './components/Pagination';

export const BaseTable = (props) => {
  const {
    pagination,
    onPageChange,
    title,
    pageSizeOptions,
    showRowsPerPage,
    onLimitChange,
    onRow,
    ...rest
  } = props;

  return (
    <div className="base-table">
      {title && <span className="base-table__title">{title}</span>}
      {pagination && (
        <BaseTablePagination
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
          pagination={pagination}
          pageSizeOptions={pageSizeOptions}
          showRowsPerPage={showRowsPerPage}
        />
      )}
      <Table {...rest} pagination={false} onRow={onRow} />
    </div>
  );
};

BaseTable.defaultProps = {
  pagination: {},
  onPageChange: () => {},
  onLimitChange: () => {},
  title: undefined,
  showRowsPerPage: false,
  pageSizeOptions: [],
  onRow: () => {}
};

BaseTable.propTypes = {
  pagination: PropTypes.oneOfType([
    PropTypes.shape({
      stateProp: PropTypes.string.isRequired,
      page: PropTypes.number.isRequired,
      limit: PropTypes.number.isRequired
    }),
    PropTypes.bool
  ]),
  onPageChange: PropTypes.func,
  title: PropTypes.string,
  showRowsPerPage: PropTypes.bool,
  onLimitChange: PropTypes.func,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  onRow: PropTypes.func
};
